import { render, staticRenderFns } from "./zExpansionConfigItem.vue?vue&type=template&id=a26fd07e&scoped=true&"
import script from "./zExpansionConfigItem.vue?vue&type=script&setup=true&lang=js&"
export * from "./zExpansionConfigItem.vue?vue&type=script&setup=true&lang=js&"
import style0 from "./zExpansionConfigItem.vue?vue&type=style&index=0&id=a26fd07e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a26fd07e",
  null
  
)

export default component.exports